import { contacts, services } from '../config/site';

export function Services() {
  return (
    <section className="services section-axis" id="services" aria-labelledby="services-title">
      <div className="page-shell section-frame" data-reveal>
        <div className="services-head">
          <div>
            <span className="eyebrow">Как я работаю</span>
            <h2 id="services-title">Одна задача.<br />Связанные решения.</h2>
          </div>
          <p>Каждый этап помогает следующему. Не отдельные услуги ради галочки, а понятный путь к результату.</p>
        </div>

        <ol className="service-list">
          {services.map((service) => (
            <li className="service-row" key={service.action}>
              <strong>{service.action}</strong>
              <div>
                <h3>{service.name}</h3>
                <p>{service.description}</p>
              </div>
              <a href={contacts.emailHref} aria-label={`Обсудить направление: ${service.name}`}><span aria-hidden="true">→</span></a>
            </li>
          ))}
        </ol>

        <div className="services-foot">
          <span className="eyebrow">Стратегия → реклама → сайт → аналитика</span>
          <p>Система важнее отдельных инструментов.</p>
        </div>
      </div>
    </section>
  );
}
